import initialState from './state'

export function resetState(state) {
  Object.assign(state, initialState())
}

export function setGeneralSettings(state, value) {
  state.general = value
}
